import controller from './login-home-controller';
import template from './login-home.html';

const LoginHomeComponent = {
    bindings: {
        loginErrorMessage: '<'
    },
    controller,
    template,
};

export default LoginHomeComponent;



// WEBPACK FOOTER //
// ./app/components/home/login-home/login-home-component.js